<template>
    <apexchart width="100%"
               height="270"
               type="line"
               :options="options"
               :series="series" />
</template>

<script>
    import apexchart from 'vue3-apexcharts';
    import { addChartWatermark } from '../helpers/helpers';
    import { getTrans } from '../helpers/getTrans';

    export default {
        name: 'BalanceChart',
        components: {
            apexchart,
        },
        props: {
            protocol: {
                type: String,
                default: 'ETH',
                required: true,
            },
            dates: {
                type: [Array, Object],
                default: () => [],
                required: true,
            },
            balance: {
                type: [Array, Object],
                default: () => [],
                required: true,
            },
            tokenBalance: {
                type: [Array, Object],
                default: () => [],
                required: true,
            },
            totalBalance: {
                type: [Array, Object],
                default: () => [],
                required: true,
            },
        },
        data() {
            return {
                series: [
                    {
                        name: this.protocol + getTrans('tools.balanceInUsd', ' Balance in USD'),
                        data: this.balance,
                    },
                    {
                        name: getTrans('tools.tokenBalanceInUsd', 'Token Balance in USD'),
                        data: this.tokenBalance,
                    },
                    {
                        name: getTrans('tools.totalBalanceInUsd', 'Token Balance in USD'),
                        data: this.totalBalance,
                    },
                ],
                options: {
                    annotations: {
                        position: 'back',
                        images: [{
                            path: 'https://assets.bitdegree.org/crypto-prices/assets/bitdegree-watermark.png',
                            width: 97,
                            height: 30,
                            x: 10,
                            y: 5,
                            appendTo: '.apexcharts-grid',
                        }],
                    },
                    chart: {
                        type: 'line',
                        zoom: {
                            enabled: false,
                        },
                        toolbar: {
                            show: false,
                            tools: {
                                download: '<i class="fa-solid fa-share"></i>',
                            },
                        },
                    },
                    grid: {
                        show: false,
                    },
                    dataLabels: {
                        distributed: true,
                        enabled: false,
                    },
                    stroke: {
                        width: 2,
                        curve: 'smooth',
                    },
                    yaxis: {
                        labels: {
                            formatter(val) {
                                if (val >= 1000000000) {
                                    return `$${(val / 1000000000).toFixed(2).replace(/\.0$/, '')}B`;
                                }
                                if (val >= 1000000) {
                                    return `$${(val / 1000000).toFixed(2).replace(/\.0$/, '')}M`;
                                }
                                if (val >= 1000) {
                                    return `$${(val / 1000).toFixed(2).replace(/\.0$/, '')}K`;
                                }

                                return `$${(val).toFixed(2)}`;
                            },
                        },
                    },
                    tooltip: {
                        shared: true,
                        y: {
                            formatter(val) {
                                if (typeof val === 'undefined') {
                                    return null;
                                }
                                if (val >= 1000000000) {
                                    return `$${(val / 1000000000).toFixed(2).replace(/\.0$/, '')}B`;
                                }
                                if (val >= 1000000) {
                                    return `$${(val / 1000000).toFixed(2).replace(/\.0$/, '')}M`;
                                }
                                if (val >= 1000) {
                                    return `$${(val / 1000).toFixed(2).replace(/\.0$/, '')}K`;
                                }

                                return `$${(val).toFixed(2)}`;
                            },
                        },
                    },
                    xaxis: {
                        categories: this.dates,
                        type: 'datetime',
                    },
                },
            };
        },
        mounted() {
            this.options.annotations.images[0].path = this.addChartWatermark(null);
        },
        methods: {
            addChartWatermark,
        },
    };
</script>
